var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User_List",
    transform: "translate(-24.000000, -178.000000)",
    fill: "#B9B9B8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Links",
    transform: "translate(0.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Submissions-Link",
    transform: "translate(0.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9085714,16 L25.9869388,16 C24.8897959,16 24,15.1102041 24,14.0114286 L24,2.08163265 C24,0.984489796 24.9028571,0 26,0 L38.0016327,0 C39.0987755,0 40,0.90122449 40,2 L40,14 C39.9983673,15.0955102 39.0040816,16 37.9085714,16 Z M38.4984848,2.42878788 C38.4984848,1.91969697 38.0787879,1.5 37.5712121,1.5 L26.4348485,1.5 C25.9257576,1.5 25.5,1.99545455 25.5,2.50454545 L25.5,13.5757576 C25.5,14.0848485 25.9121212,14.5 26.4227273,14.5 L37.4878788,14.5 C37.9969697,14.5 38.5,14.0757576 38.5,13.5651515 L38.4984848,2.42878788 L38.4984848,2.42878788 Z M36.0016327,11.5 L28,11.5 C27.7240816,11.5 27.5004082,11.1642157 27.5004082,10.75 C27.5004082,10.3357843 27.7240816,10 28,10 L36,10 C36.2759184,10 36.4995918,10.3357843 36.4995918,10.75 C36.4995918,11.1642157 36.2759184,11.5 36.0016327,11.5 Z M36.0016327,8.49918367 L28,8.49918367 C27.7240816,8.49918367 27.5004082,8.16339936 27.5004082,7.74918367 C27.5004082,7.33496799 27.7240816,6.99918367 28,6.99918367 L36,6.99918367 C36.2759184,6.99918367 36.4996007,7.33741897 36.4996007,7.74918367 C36.5012245,8.16094838 36.2759184,8.49918367 36.0016327,8.49918367 Z M36.0016327,5.5 L28,5.5 C27.7240816,5.5 27.5004082,5.16421569 27.5004082,4.75 C27.5004082,4.33578431 27.7240816,4 28,4 L36,4 C36.2759184,4 36.4995918,4.33578431 36.4995918,4.75 C36.4995918,5.16421569 36.2759184,5.5 36.0016327,5.5 Z",
    id: "Shape"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/Shape.f4ccf1c376803a9b87debe4ea8884d49.svg";
export { ForwardRef as ReactComponent };